import { ContentType } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import * as z from "zod";
import { literal, object, string } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableContentMessageSchema,
} from "../message-parser-utils";

/**
 * Message type for displaying a product visualization result.
 * Contains the URL of the generated visualization image.
 */
export const ProductVisualizationResultMessageSchema =
  BaseActionableContentMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_VISUALIZATION_RESULT),
    structuredContent: object({
      visualizationUrl: string(),
      productId: string().optional(),
      variantId: string().optional(),
    }).optional(),
  });

export type ProductVisualizationResultMessage = z.infer<
  typeof ProductVisualizationResultMessageSchema
>;

export const ProductVisualizationResultMessageDbParser =
  ProductVisualizationResultMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductVisualizationResultMessageType = z.infer<
  typeof ProductVisualizationResultMessageDbParser
>;
